import { useState } from 'react';

interface Props {
  initialState?: boolean;
}

const useSwitch = ({ initialState = false }: Props = {}) => {
  const [active, setActive] = useState(initialState);

  const toggle = (state?: boolean) => {
    setActive(prev => (state !== undefined ? state : !prev));
  };

  const activate = () => {
    setActive(true);
  };

  const deactivate = () => {
    setActive(false);
  };

  return { active, toggle, activate, deactivate };
};

export default useSwitch;
